import { AxiosError, AxiosRequestConfig } from "axios";
import Api from "network/api";

export function apiInit() {
  Api.init({
    config: { baseURL: process.env.REACT_APP_API_BASE_URL as string },
    interceptors: {
      request: requestHandler,
      response: {
        onRejected: responseErrorHandler,
      },
    },
  });
}

function requestHandler(
  request: AxiosRequestConfig
): Promise<AxiosRequestConfig> {
  const cb = () => {
    return Promise.resolve({
      ...request,
      headers: {
        ...request?.headers,
        Authorization: `Bearer ${localStorage.getItem("TOKEN")}`,
      },
    });
  };
  return cb();
}

function responseErrorHandler(error: AxiosError) {
  try {
    if (error.response?.status === 401) {
      // Show session expired notification

      // Remove token from local storage
      localStorage.removeItem("TOKEN");

      // Redirect to login page after a short delay
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
    }
  } catch (error) {
    console.log("==========>", error);
  }
  return Promise.reject(error);
}
